module.exports = __webpack_public_path__ + "img/4-3-1-4-1-preview-HKCA-e.982d3fd4.jpg";